import axiosPrivateMl from "@services/axiosPrivateMl"
import { UNGROUP_CREATIVES_URL } from "../../constants"

export const ungroupCreatives = (data) => {
  return axiosPrivateMl.post(UNGROUP_CREATIVES_URL, data)
}
